import { render, staticRenderFns } from "./incorrectlist.vue?vue&type=template&id=23435fc6&scoped=true"
import script from "./incorrectlist.vue?vue&type=script&lang=js"
export * from "./incorrectlist.vue?vue&type=script&lang=js"
import style0 from "./incorrectlist.vue?vue&type=style&index=0&id=23435fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23435fc6",
  null
  
)

export default component.exports